// extracted by mini-css-extract-plugin
export default {"success":"yW9mOKIJ","mobile":"mobile","link":"ZyX02w0O"};